import { IImage } from '@gn-audio/core/api/product-catalogue/models/image';
import { IProductWithAttributes } from '@gn-audio/core/api/product-catalogue/models/product-with-attributes';
import { Component, Input, Output } from 'angular-ts-decorators';
import { customPaging } from './utils/custom-paging';

import template from './hero-customizer-v2.image-gallery.component.html';

@Component({
  selector: 'heroCustomizerV2ImageGallery',
  template,
})
export class HeroCustomizerV2ImageGalleryComponent {
  public static $inject: ReadonlyArray<string> = [];

  @Input() public images?: IImage[];
  @Input() public group?: IProductWithAttributes;

  @Output() public onClose?: () => void;

  public customPaging(slick: any, index: number): string {
    return customPaging(this.images, index, this.group.productName);
  }
}
